import { render, staticRenderFns } from "./HospitalRegistration.vue?vue&type=template&id=2919f82e"
import script from "./HospitalRegistration.vue?vue&type=script&lang=js"
export * from "./HospitalRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports